export default __webpack_public_path__ + "static/media/grains_seeds_2.c23c9c0c.jpg";